// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Agent-activity indicator styling.
 *
 * Colour comes from the IDE design-system variables in \`ide.css\` (including the
 * \`--color-ide-agent-*\` additions); nothing here hardcodes a hex value, so both
 * themes and any future re-theme carry through.
 *
 * Motion budget: every animation below has a period of 1.3s or slower and moves
 * opacity, scale or position only. Nothing strobes, and \`prefers-reduced-motion\`
 * turns all of it off while keeping the colour and the wording.
 */

/* ---------------------------------------------------------------- */
/* Keyframes                                                         */
/* ---------------------------------------------------------------- */

@keyframes agent-pulse-dot {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.35;
    transform: scale(0.78);
  }
}

/* Expanding halo behind the dot: adds presence without adding brightness. */
@keyframes agent-pulse-halo {
  0% {
    opacity: 0.55;
    transform: scale(0.7);
  }
  100% {
    opacity: 0;
    transform: scale(2.4);
  }
}

/* Indeterminate sweep. It carries no completion semantics — it only says that
   time is passing and the agent is still on it. */
@keyframes agent-progress-sweep {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(400%);
  }
}

/* One-shot settle, so completion registers as an event rather than appearing
   to have always been there. */
@keyframes agent-done-settle {
  0% {
    opacity: 0;
    transform: translateY(-4px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ---------------------------------------------------------------- */
/* Dots                                                              */
/* ---------------------------------------------------------------- */

.agent-dot {
  border-radius: 9999px;
  flex-shrink: 0;
}

.agent-dot-working {
  background-color: var(--color-ide-agent-working);
  animation: agent-pulse-dot 1.3s ease-in-out infinite;
}

/* Idle is a hollow ring, not a filled grey dot: filled grey reads as a
   disabled control, and the message here is "ready", not "off". */
.agent-dot-idle {
  background-color: transparent;
  box-shadow: inset 0 0 0 1.5px var(--color-ide-text-dim);
}

.agent-halo {
  position: absolute;
  inset: 0;
  border-radius: 9999px;
  background-color: var(--color-ide-agent-working);
  animation: agent-pulse-halo 1.6s ease-out infinite;
  pointer-events: none;
}

/* ---------------------------------------------------------------- */
/* Progress track                                                    */
/* ---------------------------------------------------------------- */

.agent-progress-track {
  position: relative;
  overflow: hidden;
  background-color: var(--color-ide-agent-working-soft);
}

.agent-progress-track > .agent-progress-bar {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 25%;
  background-color: var(--color-ide-agent-working-strong);
  animation: agent-progress-sweep 1.5s ease-in-out infinite;
}

/* ---------------------------------------------------------------- */
/* Panel edge                                                        */
/* ---------------------------------------------------------------- */

/* An inset ring rather than a border, so the panel does not change size
   between phases and nothing reflows. */
.agent-panel-ring-working {
  box-shadow: inset 0 0 0 2px var(--color-ide-agent-working);
}

.agent-panel-ring-done {
  box-shadow: inset 0 0 0 2px var(--color-ide-agent-done);
}

.agent-settle {
  animation: agent-done-settle 220ms ease-out;
}

/* ---------------------------------------------------------------- */
/* Status strip under the panel header                               */
/* ---------------------------------------------------------------- */

.agent-status-strip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  user-select: none;
  flex-shrink: 0;
  transition: background-color 220ms ease-out;
}

.agent-status-strip-working {
  background-color: var(--color-ide-agent-working);
  color: var(--color-ide-agent-on-strong);
}

.agent-status-strip-done {
  background-color: var(--color-ide-agent-done);
  color: var(--color-ide-agent-on-strong);
}

/* Idle keeps the strip present but demotes it to chrome. Reserving the space is
   the point: the strip never disappears, so its colour is the whole signal. */
.agent-status-strip-idle {
  background-color: var(--color-ide-surface-2);
  color: var(--color-ide-text-muted);
}

/* ---------------------------------------------------------------- */
/* Reduced motion                                                    */
/* ---------------------------------------------------------------- */

/* Someone who asks for less motion still needs to know the agent is busy, so
   only the animation stops; colour, copy and the elapsed counter remain. */
@media (prefers-reduced-motion: reduce) {
  .agent-dot-working,
  .agent-halo,
  .agent-progress-track > .agent-progress-bar,
  .agent-settle {
    animation: none;
  }
  .agent-halo {
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AgentActivity/agentActivity.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF,qEAAqE;AACrE,sEAAsE;AACtE,qEAAqE;;AAErE;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA,4EAA4E;AAC5E;EACE;IACE,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;kDACkD;AAClD;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;+BAC+B;AAC/B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qEAAqE;AACrE,sEAAsE;AACtE,qEAAqE;;AAErE;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,oDAAoD;AACtD;;AAEA;kEACkE;AAClE;EACE,6BAA6B;EAC7B,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,gDAAgD;EAChD,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA,qEAAqE;AACrE,sEAAsE;AACtE,qEAAqE;;AAErE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,uDAAuD;EACvD,yDAAyD;AAC3D;;AAEA,qEAAqE;AACrE,sEAAsE;AACtE,qEAAqE;;AAErE;wCACwC;AACxC;EACE,0DAA0D;AAC5D;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,qEAAqE;AACrE,sEAAsE;AACtE,qEAAqE;;AAErE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,gDAAgD;EAChD,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;8EAC8E;AAC9E;EACE,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA,qEAAqE;AACrE,sEAAsE;AACtE,qEAAqE;;AAErE;2EAC2E;AAC3E;EACE;;;;IAIE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["/*\n * Agent-activity indicator styling.\n *\n * Colour comes from the IDE design-system variables in `ide.css` (including the\n * `--color-ide-agent-*` additions); nothing here hardcodes a hex value, so both\n * themes and any future re-theme carry through.\n *\n * Motion budget: every animation below has a period of 1.3s or slower and moves\n * opacity, scale or position only. Nothing strobes, and `prefers-reduced-motion`\n * turns all of it off while keeping the colour and the wording.\n */\n\n/* ---------------------------------------------------------------- */\n/* Keyframes                                                         */\n/* ---------------------------------------------------------------- */\n\n@keyframes agent-pulse-dot {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.35;\n    transform: scale(0.78);\n  }\n}\n\n/* Expanding halo behind the dot: adds presence without adding brightness. */\n@keyframes agent-pulse-halo {\n  0% {\n    opacity: 0.55;\n    transform: scale(0.7);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(2.4);\n  }\n}\n\n/* Indeterminate sweep. It carries no completion semantics — it only says that\n   time is passing and the agent is still on it. */\n@keyframes agent-progress-sweep {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(400%);\n  }\n}\n\n/* One-shot settle, so completion registers as an event rather than appearing\n   to have always been there. */\n@keyframes agent-done-settle {\n  0% {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ---------------------------------------------------------------- */\n/* Dots                                                              */\n/* ---------------------------------------------------------------- */\n\n.agent-dot {\n  border-radius: 9999px;\n  flex-shrink: 0;\n}\n\n.agent-dot-working {\n  background-color: var(--color-ide-agent-working);\n  animation: agent-pulse-dot 1.3s ease-in-out infinite;\n}\n\n/* Idle is a hollow ring, not a filled grey dot: filled grey reads as a\n   disabled control, and the message here is \"ready\", not \"off\". */\n.agent-dot-idle {\n  background-color: transparent;\n  box-shadow: inset 0 0 0 1.5px var(--color-ide-text-dim);\n}\n\n.agent-halo {\n  position: absolute;\n  inset: 0;\n  border-radius: 9999px;\n  background-color: var(--color-ide-agent-working);\n  animation: agent-pulse-halo 1.6s ease-out infinite;\n  pointer-events: none;\n}\n\n/* ---------------------------------------------------------------- */\n/* Progress track                                                    */\n/* ---------------------------------------------------------------- */\n\n.agent-progress-track {\n  position: relative;\n  overflow: hidden;\n  background-color: var(--color-ide-agent-working-soft);\n}\n\n.agent-progress-track > .agent-progress-bar {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 25%;\n  background-color: var(--color-ide-agent-working-strong);\n  animation: agent-progress-sweep 1.5s ease-in-out infinite;\n}\n\n/* ---------------------------------------------------------------- */\n/* Panel edge                                                        */\n/* ---------------------------------------------------------------- */\n\n/* An inset ring rather than a border, so the panel does not change size\n   between phases and nothing reflows. */\n.agent-panel-ring-working {\n  box-shadow: inset 0 0 0 2px var(--color-ide-agent-working);\n}\n\n.agent-panel-ring-done {\n  box-shadow: inset 0 0 0 2px var(--color-ide-agent-done);\n}\n\n.agent-settle {\n  animation: agent-done-settle 220ms ease-out;\n}\n\n/* ---------------------------------------------------------------- */\n/* Status strip under the panel header                               */\n/* ---------------------------------------------------------------- */\n\n.agent-status-strip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 10px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  user-select: none;\n  flex-shrink: 0;\n  transition: background-color 220ms ease-out;\n}\n\n.agent-status-strip-working {\n  background-color: var(--color-ide-agent-working);\n  color: var(--color-ide-agent-on-strong);\n}\n\n.agent-status-strip-done {\n  background-color: var(--color-ide-agent-done);\n  color: var(--color-ide-agent-on-strong);\n}\n\n/* Idle keeps the strip present but demotes it to chrome. Reserving the space is\n   the point: the strip never disappears, so its colour is the whole signal. */\n.agent-status-strip-idle {\n  background-color: var(--color-ide-surface-2);\n  color: var(--color-ide-text-muted);\n}\n\n/* ---------------------------------------------------------------- */\n/* Reduced motion                                                    */\n/* ---------------------------------------------------------------- */\n\n/* Someone who asks for less motion still needs to know the agent is busy, so\n   only the animation stops; colour, copy and the elapsed counter remain. */\n@media (prefers-reduced-motion: reduce) {\n  .agent-dot-working,\n  .agent-halo,\n  .agent-progress-track > .agent-progress-bar,\n  .agent-settle {\n    animation: none;\n  }\n  .agent-halo {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
